module.exports = __webpack_public_path__ + "536c39a65827f4b8502a1f0ca1618777.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/paper--plane.png
 ** module id = 1574
 ** module chunks = 0
 **/